/* cs-localization.js · Consiglieri · Brief final RO/EN v1.3 (09.09.2026)
 * Selector RO/EN + memorarea preferinței + recomandare contextuală neblocantă.
 * Reguli: linkuri reale (navigare implicită păstrată, fără preventDefault pe schimbarea domeniului), fără History API,
 * sesiune = sessionStorage per tab/origine, o singură afișare/sesiune, fără retry API, idempotent, curățare la unload.
 * Preferința: {language, chosen_at, expires_at} (≤180 zile); dismiss_until 30 zile; marker de transfer cs_lang_choice/cs_lang_at
 * (valid ≤10 min în trecut, ≤60 s în viitor; nu suprascrie o alegere locală mai nouă). Nu transportă PII, nu atinge consimțământul.
 */
(function () {
  'use strict';
  if (window.__csLocalizationInit) { return; }
  window.__csLocalizationInit = true;

  var PREF_KEY = 'cs_lang_pref';
  var DISMISS_KEY = 'cs_lang_dismiss_until';
  var SHOWN_KEY = 'cs_lang_suggest_shown';
  var GEO_KEY = 'cs_lang_geo';
  var PREF_TTL = 180 * 24 * 60 * 60 * 1000;
  var DISMISS_TTL = 30 * 24 * 60 * 60 * 1000;
  var MARKER_PAST = 10 * 60 * 1000;
  var MARKER_FUTURE = 60 * 1000;
  var SHOW_DELAY = 2000;
  var GEO_TIMEOUT = 2000;
  var LANGS = { ro: true, en: true };

  function now() { return Date.now(); }
  function isLang(v) { return typeof v === 'string' && LANGS[v] === true; }
  function isInt(v) { return typeof v === 'number' && isFinite(v) && Math.floor(v) === v && v > 0; }

  var store = {
    get: function (kind, key) {
      try { var s = kind === 'session' ? window.sessionStorage : window.localStorage; return s.getItem(key); } catch (e) { return null; }
    },
    set: function (kind, key, val) {
      try { var s = kind === 'session' ? window.sessionStorage : window.localStorage; s.setItem(key, val); return true; } catch (e) { return false; }
    },
    remove: function (kind, key) {
      try { var s = kind === 'session' ? window.sessionStorage : window.localStorage; s.removeItem(key); } catch (e) {}
    },
    probe: function (kind) {
      try { var s = kind === 'session' ? window.sessionStorage : window.localStorage; var k = '__cs_probe'; s.setItem(k, '1'); s.removeItem(k); return true; } catch (e) { return false; }
    }
  };

  function readPref() {
    var raw = store.get('local', PREF_KEY);
    if (!raw) { return null; }
    try {
      var p = JSON.parse(raw);
      if (!p || !isLang(p.language) || !isInt(p.chosen_at) || !isInt(p.expires_at)) { return null; }
      if (p.expires_at <= now() || p.chosen_at > now() + MARKER_FUTURE) { return null; }
      return p;
    } catch (e) { return null; }
  }
  function writePref(language, chosenAt) {
    if (!isLang(language)) { return null; }
    var at = isInt(chosenAt) ? chosenAt : now();
    var existing = readPref();
    if (existing && existing.chosen_at > at) { return existing; }
    if (existing && existing.chosen_at === at && existing.language === language) { return existing; }
    var p = { language: language, chosen_at: at, expires_at: at + PREF_TTL };
    store.set('local', PREF_KEY, JSON.stringify(p));
    return p;
  }
  function readDismiss() {
    var v = parseInt(store.get('local', DISMISS_KEY) || store.get('session', DISMISS_KEY) || '0', 10);
    return isInt(v) ? v : 0;
  }
  function writeDismiss() {
    var until = now() + DISMISS_TTL;
    if (!store.set('local', DISMISS_KEY, String(until))) { store.set('session', DISMISS_KEY, String(until)); }
  }

  /* ---------- marker de transfer de pe URL (fără curățare History API) ---------- */
  function readMarker() {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return null; }
    var lang = params.get('cs_lang_choice');
    var at = parseInt(params.get('cs_lang_at') || '', 10);
    if (!isLang(lang) || !isInt(at)) { return null; }
    var t = now();
    if (at < t - MARKER_PAST || at > t + MARKER_FUTURE) { return null; }
    return { language: lang, chosen_at: at };
  }

  /* ---------- decorarea sincronă a ancorei către celălalt domeniu ---------- */
  function decorate(a, lang) {
    if (!a || !isLang(lang)) { return; }
    var href = a.getAttribute('href');
    if (!href) { return; }
    var url;
    try { url = new URL(href, window.location.href); } catch (e) { return; }
    url.searchParams.set('cs_lang_choice', lang);
    url.searchParams.set('cs_lang_at', String(now()));
    a.setAttribute('href', url.toString());
  }

  /* ---------- selector ---------- */
  function initSwitch(nav) {
    if (!nav || nav.__cs) { return; }
    nav.__cs = true;
    var current = nav.getAttribute('data-cs-lang');
    var links = nav.querySelectorAll('a[data-cs-lang-choice]');
    Array.prototype.forEach.call(links, function (a) {
      var lang = a.getAttribute('data-cs-lang-choice');
      var same = lang === current;
      var arm = function () { if (!same) { writePref(lang); decorate(a, lang); } };
      a.addEventListener('mousedown', arm);
      a.addEventListener('touchstart', arm, { passive: true });
      a.addEventListener('keydown', function (ev) { if (ev.key === 'Enter' || ev.key === ' ') { arm(); } });
      a.addEventListener('click', function (ev) {
        if (same) {
          ev.preventDefault();
          writePref(lang);
          hideCard();
          return;
        }
        arm();
      });
    });
  }

  /* ---------- card ---------- */
  var card = null;
  var cardTimer = null;
  var cardRequestId = 0;
  function hideCard() {
    if (!card || card.hidden) { return; }
    var hadFocus = card.contains(document.activeElement);
    card.hidden = true;
    if (hadFocus) {
      var opt = document.querySelector('.cs-lang a[data-cs-lang-choice]');
      if (opt) { try { opt.focus({ preventScroll: true }); } catch (e) { opt.focus(); } }
    }
  }
  function uiBusy() {
    if (document.visibilityState !== 'visible') { return true; }
    if (document.querySelector('dialog[open]')) { return true; }
    var ae = document.activeElement;
    if (ae && ae !== document.body && ae.closest && ae.closest('form, dialog, [role="dialog"], .header-sidebar, [data-cs-form]')) { return true; }
    if (document.querySelector('.pandectes-drawer.visible, .pandectes-banner:not([hidden]) , #pandectes-banner:not([style*="display: none"])')) { return true; }
    return false;
  }
  function browserLang() {
    var list = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || ''];
    for (var i = 0; i < list.length; i++) {
      var l = String(list[i] || '').toLowerCase().slice(0, 2);
      if (isLang(l)) { return l; }
    }
    return null;
  }
  function geoSuggest(endpoint, cb) {
    var cached = store.get('session', GEO_KEY);
    if (cached) { cb(cached === 'fail' ? null : cached); return; }
    if (!endpoint || typeof fetch !== 'function' || typeof AbortController !== 'function') { cb(null); return; }
    var ctrl = new AbortController();
    var timer = setTimeout(function () { ctrl.abort(); }, GEO_TIMEOUT);
    var url = endpoint + (endpoint.indexOf('?') > -1 ? '&' : '?') + 'country[enabled]=true&language[enabled]=true';
    fetch(url, { credentials: 'same-origin', signal: ctrl.signal, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        clearTimeout(timer);
        var country = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
        var val = country ? String(country).toUpperCase() : 'fail';
        store.set('session', GEO_KEY, val);
        cb(val === 'fail' ? null : val);
      })
      .catch(function () { clearTimeout(timer); store.set('session', GEO_KEY, 'fail'); cb(null); });
  }
  function recommend(current, cb) {
    var pref = readPref();
    if (pref) { cb(pref.language !== current ? pref.language : null); return; }
    var bl = browserLang();
    if (bl) { cb(bl !== current ? bl : null); return; }
    if (current === 'ro' && card && card.getAttribute('data-cs-suggest-endpoint')) {
      geoSuggest(card.getAttribute('data-cs-suggest-endpoint'), function (country) {
        cb(country && country !== 'RO' ? 'en' : null);
      });
      return;
    }
    cb(null);
  }
  function initCard(el) {
    if (!el || el.__cs) { return; }
    el.__cs = true;
    card = el;
    var current = el.getAttribute('data-cs-current');
    var wanted = el.getAttribute('data-cs-recommend');
    var primary = el.querySelector('a[data-cs-lang-choice]');
    var stay = el.querySelector('[data-cs-lang-stay]');
    var close = el.querySelector('[data-cs-lang-dismiss]');
    if (primary) {
      var arm = function () { writePref(wanted); decorate(primary, wanted); };
      primary.addEventListener('mousedown', arm);
      primary.addEventListener('touchstart', arm, { passive: true });
      primary.addEventListener('keydown', function (ev) { if (ev.key === 'Enter' || ev.key === ' ') { arm(); } });
      primary.addEventListener('click', arm);
    }
    if (stay) { stay.addEventListener('click', function () { cardRequestId++; writePref(current); hideCard(); }); }
    if (close) { close.addEventListener('click', function () { cardRequestId++; writeDismiss(); hideCard(); }); }

    if (!store.probe('session')) { return; }
    if (store.get('session', SHOWN_KEY)) { return; }
    if (readDismiss() > now()) { return; }
    var pref = readPref();
    if (pref && pref.language === current) { return; }
    var myId = ++cardRequestId;
    recommend(current, function (lang) {
      if (myId !== cardRequestId || !lang || lang !== wanted) { return; }
      cardTimer = setTimeout(function () {
        if (myId !== cardRequestId) { return; }
        if (uiBusy()) { return; }
        if (store.get('session', SHOWN_KEY)) { return; }
        if (!store.set('session', SHOWN_KEY, String(now()))) { return; }
        el.hidden = false;
      }, SHOW_DELAY);
    });
  }

  function boot() {
    var marker = readMarker();
    var pageLang = (document.documentElement.getAttribute('lang') || '').toLowerCase().slice(0, 2);
    if (marker && marker.language === pageLang) { writePref(marker.language, marker.chosen_at); }
    Array.prototype.forEach.call(document.querySelectorAll('.cs-lang[data-cs-lang]'), initSwitch);
    initCard(document.querySelector('[data-cs-lang-suggest]'));
  }
  function teardown() {
    cardRequestId++;
    if (cardTimer) { clearTimeout(cardTimer); cardTimer = null; }
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  window.addEventListener('pageshow', function (ev) { if (ev.persisted) { teardown(); boot(); } });
  window.addEventListener('pagehide', teardown);
  document.addEventListener('shopify:section:load', function () { Array.prototype.forEach.call(document.querySelectorAll('.cs-lang[data-cs-lang]'), initSwitch); });
})();
